import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{
 *   $refs: {
 *     play: HTMLButtonElement;
 *     videoPlayer: HTMLVideoElement;
 *     videoCover: HTMLElement;
 *   }
 * }} VideoProps
 */

/**
 * Video component.
 * @augments {Base<VideoProps>}
 */
export default class WishlistPopin extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'WishlistPopin',
    refs: ['container', 'close'],
  };

  /**
   * Open Popin
   * @param {string} content Html to render in popin
   */
  open(content) {
    this.$refs.container.innerHTML = content;

    this.$el.classList.remove('translate-y-full');
  }

  /**
   * Close Popin
   */
  close() {
    this.$el.classList.add('translate-y-full');
  }

  /**
   *
   */
  onCloseClick() {
    this.close();
  }
}
